// extracted by mini-css-extract-plugin
export default {"record-writebox":"BloodPressureWrite_record-writebox__1rjiy","date-record":"BloodPressureWrite_date-record__cE9Uv","time-record":"BloodPressureWrite_time-record__ouCxl"};